/**
 * Upholstery **V2** — structural PDM → configurator merges (isolate from legacy blob overlays).
 */

export {
  mergeConfigurableStepsFromPdmProducts,
  type UpholsteryVehicleContext,
} from "./helpers/steps/buildConfigurableStepsFromPdmProducts"

export {
  overlayDatoSkusOnPdmOptions,
  overlayDatoRowAssetsOnPdmOptions,
} from "./helpers/steps/pdm-option-sku"
export {
  fetchPdmAssetRowConfigurations,
  prefetchPdmAssetRowConfigurations,
} from "./helpers/data/fetchPdmAssetRows"
export type { PdmAssetRowConfiguration, PdmAssetRecord } from "./types"

export {
  getUpholsteryVehicleList,
  useUpholsteryVehicleList,
} from "./helpers/vehicle/getUpholsteryVehicleList"
export { isPdmStructureV2Enabled } from "./helpers/flags/isPdmStructureV2Enabled"
export { isUpholsteryStepsV2Enabled } from "./helpers/flags/isUpholsteryStepsV2Enabled"
export { isPdmOnlyVehiclesEnabled } from "./helpers/flags/isPdmOnlyVehiclesEnabled"
export { buildSyntheticUpholsteryCar } from "./helpers/vehicle/buildSyntheticUpholsteryCar"
export {
  deriveVehicleCatalogFromPdm,
  expandApplicationYears,
  type PdmVehicleCatalogResult,
  type PdmVehicleCatalogStats,
} from "./pdm/deriveVehicleCatalogFromPdm"
export {
  usePdmVehicleCatalogStore,
  clearPersistedPdmVehicleCatalog,
  PDM_VEHICLE_CATALOG_CACHE_VERSION,
} from "./store/pdm-vehicle-catalog-store"
export {
  useUpholsteryStepsV2Store,
  type UpholsteryStepsV2State,
} from "./store/upholstery-steps-v2-store"
export {
  loadPdmVehicleCatalogIntoStore,
  cancelPdmVehicleCatalogLoad,
  resetPdmVehicleCatalogSessionLoad,
  PDM_CATALOG_LOAD_ERROR,
} from "./helpers/vehicle/loadPdmVehicleCatalogIntoStore"
export { useLoadPdmVehicleCatalog } from "./hooks/useLoadPdmVehicleCatalog"
export { useGlobalVehicleCatalogLoader } from "./hooks/useGlobalVehicleCatalogLoader"
export { usePickerCars } from "./hooks/usePickerCars"
export { useUpholsteryV2VehiclePicker } from "./hooks/useUpholsteryV2VehiclePicker"
export { loadUpholsteryVehicleSelection } from "./helpers/vehicle/loadUpholsteryVehicleSelection"
export {
  getStyleStepsSourceDetails,
  logStyleStepsSource,
  logVehicleRecordSource,
  isLocalUpholsteryDebug,
  type StyleStepsSource,
  type StyleStepsSourceDetails,
  type StyleStepsSourceMatch,
  type VehicleRecordSource,
} from "./helpers/debug/debugStyleStepsSource"
export {
  deriveM3SkusFromPdmBases,
  type DerivedM3Skus,
} from "./helpers/steps/deriveM3SkusFromPdmBases"
export { overlayDatoDesignDefaultsOnSteps } from "./helpers/steps/overlayDatoDesignDefaultsOnSteps"
export {
  fetchUpholsteryStepsV2,
  spliceGlobalStyleSteps,
  withoutGlobalStyleSteps,
  overlayMissingBuildPricesFromCar,
  mapUpholsteryStepsV2RecordToStep,
  GLOBAL_STYLE_STEP_KEYS,
  isGlobalStyleStepKey,
} from "./helpers/steps/fetchUpholsteryStepsV2"
export { applyUpholsteryVehicleToStores } from "./helpers/steps/applyUpholsteryVehicleToStores"
export {
  fetchShopifyVariantsByMake,
  makeToShopifyVariantsKey,
  normalizeMakeKey,
  parseShopifyVariantsFromOptions,
  normalizeShopifyVariantEntry,
} from "./helpers/shopify/fetchShopifyVariantsByMake"
export {
  useShopifyVariantsByMakeStore,
  type ShopifyVariantsByMakeState,
} from "./store/shopify-variants-by-make-store"
export {
  logVehicleSelectionError,
  toVehicleSelectionErrorDisplay,
  toVehicleSelectionErrorMessage,
  VehicleNotFoundError,
  DatoStepsMissingError,
  VEHICLE_SELECTION_GENERIC_ERROR,
  PDM_PRODUCTS_UNAVAILABLE_ERROR,
  type VehicleSelectionErrorDisplay,
  type VehicleSelectionContext,
} from "./helpers/vehicle/vehicleSelectionErrors"
